// extracted by mini-css-extract-plugin
module.exports = {"headerWidgetInner":"_b8f9ad9"};